<script setup lang="ts">
import { cn } from '@/lib/utils'
import { ProgressIndicator, ProgressRoot, type ProgressRootProps } from 'reka-ui'
import { computed, type HTMLAttributes } from 'vue'

const props = withDefaults(
  defineProps<
    ProgressRootProps & {
      class?: HTMLAttributes['class']
      color?: string
    }
  >(),
  {
    modelValue: 0,
    color: 'bg-primary',
  },
)

const delegatedProps = computed(() => {
  const { class: _, color: __, ...delegated } = props
  return delegated
})
</script>

<template>
  <ProgressRoot
    v-bind="delegatedProps"
    :class="cn('relative h-3 w-full overflow-hidden rounded bg-primary/20', props.class)"
  >
    <ProgressIndicator
      :class="['h-full w-full flex-1 transition-all', props.color]"
      :style="`transform: translateX(-${100 - (props.modelValue ?? 0)}%);`"
    />
  </ProgressRoot>
</template>
